/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Nuclear() {
  return (
    <PaginasEspecificas posicao="17" endereco="/fisica" materia="Física" />
  );
}

export default Nuclear;
